import React from 'react';
import eventsData from '../../data/events.json';

type EventItem = {
  id: number;
  title: string;
  startDate: string; // ISO yyyy-mm-dd
  endDate?: string; // optional end date for ranges
  time?: string;
  description?: string;
  location?: string;
};

const formatDate = (d: Date) =>
  d.toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' });

const EventsList: React.FC = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const events = (eventsData as unknown as Array<Record<string, any>>)
    .map((e): EventItem => ({
      id: e.id,
      title: e.title,
      startDate: e.startDate ?? e.date,
      endDate: e.endDate ?? undefined,
      time: e.time,
      description: e.description,
      location: e.location,
    }))
    .map((e) => ({
      ...e,
      start: new Date(e.startDate),
      end: e.endDate ? new Date(e.endDate) : new Date(e.startDate),
    }))
    .filter((e) => {
      const end = new Date(e.end);
      end.setHours(0, 0, 0, 0);
      return end >= today; // keep if the range hasn't finished
    })
    .sort((a, b) => a.start.getTime() - b.start.getTime());

  if (events.length === 0) {
    return (
      <div className="container">
        <p>Aucun événement à venir.</p>
      </div>
    );
  }

  return (
    <div className="container events-list">
      {events.map((e) => (
        <div key={e.id} className="card event-card">
          <h3>{e.title}</h3>
          <div className="event-meta">
            <time>
              {e.start.getTime() === e.end.getTime()
                ? formatDate(e.start)
                : `Du ${formatDate(e.start)} au ${formatDate(e.end)}`}
              {e.time && e.start.getTime() === e.end.getTime() ? ` — ${e.time}` : ''}
            </time>
            {e.location && <span className="event-location"> — {e.location}</span>}
          </div>
          {e.description && <p>{e.description}</p>}
        </div>
      ))}
    </div>
  );
};

export default EventsList;
